import React, {useState, useCallback, useEffect} from "react";
import Modal from "react-bootstrap/Modal";
import DatePicker, {registerLocale} from "react-datepicker";
import {Button, Tag} from "antd";
import ApiService from "../../util/ApiService";
import debounce from "lodash.debounce";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import AuthService from "../../util/AuthService";
import Switch from "react-switch";
import ptBR from "date-fns/locale/pt-BR"; // Importar locale pt-BR
import {FaCheck, FaPlus} from "react-icons/fa"; // Importar ícones
import Select from "react-select"; // Importar react-select
import "./../assets/css/PlantaoModal.css";
import LoadingScreen from "../../util/LoadingScreen";
import EventEditor from "../../util/EventEditor";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Registrar locale pt-BR
registerLocale("pt-BR", ptBR);

const PlantaoRepostModal = ({show, handleClose, handleSubmit, duty}) => {
    const [users, setUsers] = useState(AuthService.getUserData());
    const [dutyData, setDutyData] = useState({
        id: '',
        date_time: null,
        value: '',
        hospital_id: '',
        date_time_end: null,
        self_approval: 0,
        department_id: 0,
        specialties: [],
        observation: '',
        validated_user: 0,
    });

    const [loading, setLoading] = useState(false); // Estado de carregamento
    const [loadingSave, setLoadingSave] = useState(false); // Estado de carregamento
    const [errorMessage, setErrorMessage] = useState('');
    const [allEvents, setAllEvents] = useState([]);


    // Captura os eventos atualizados do EventEditor
    const handleEventsChange = (updatedEvents) => {
        setAllEvents(updatedEvents);  // Armazena os eventos atualizados
    };




    const onChange = (event) => {
        const {value} = event.target;
        setHospitalName(value);
        setHospitalSelected(false);
        fetchSuggestions(value);
    };

    const handleSuggestionClick = (suggestion) => {
        setHospitalName(suggestion.name);
        setDutyData({
            ...dutyData,
            hospital_id: suggestion.value
        });
        setShowSuggestions(false);
        setHospitalSelected(true);
    };

    const onHospitalSelect = (hospital) => {
        if (hospital) {
            setHospitalName(hospital.name);
            setHospitalSelected(true);
            setDutyData({
                ...dutyData,
                hospital_id: hospital.value
            });
        } else {
            setHospitalSelected(false);
            setDutyData({
                ...dutyData,
                hospital_id: hospital.value
            });
        }

    };



    const save = async (e) => {
        setLoadingSave(true);
        const formattedDuty = {
            id: duty ? duty.id : null,
            cut_dates: allEvents.map(event => ({
                start: new Date(event.start).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }).replace(",", "").replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'),
                end: new Date(event.end).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }).replace(",", "").replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'),
                my_duty: event.extendedProps.my_duty ?? 1,
                id_user_accepted:  event.extendedProps.accept_user?.value ?? null,
            })),
        };

        try {
            await ApiService.send("post", `${process.env.REACT_APP_URL_API}scale/repost-scale`, formattedDuty, true);
            Swal.fire({
                title: 'Sucesso!',
                text: 'Plantão atualizado com sucesso!',
                icon: 'success',
                confirmButtonText: 'OK'
            });
            handleClose();
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSave(false); // Finaliza o carregamento
        }
    };

    useEffect(() => {
        if (show) {


            if (duty) {
                setDutyData({
                    date_time: duty ? (duty.date_time ? new Date(duty.date_time) : null) : null,
                    value: duty?.value | null,
                    hospital_id: duty?.hospital_id || null,
                    date_time_end: duty?.date_time_end ? new Date(duty.date_time_end) : null,
                    self_approval: duty?.self_approval || null,
                    specialties: duty?.specialties?.map(specialty => ({value: specialty.id, label: specialty.name})),
                    observation: duty?.observation || '',
                    validated_user: duty?.validated_user || 0,
                    user_id: duty?.user_id || null,
                });


            } else {
                setDutyData({
                    date_time: null,
                    value: '',
                    hospital_id: '',
                    date_time_end: null,
                    user_id: null,
                    self_approval: 0,
                    specialties: [],
                    observation: '',
                    validated_user: 0,
                });
            }

            setErrorMessage('');
        }
    }, [show, duty]);




    return (
        <>
            {loading && <LoadingScreen/>} {/* Exibe a tela de carregamento enquanto `loading` for true */}
            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Repostar Plantão</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={save}>
                        <div className="row">
                            <div className="col-4 form-group">
                                <label>Data Início</label><br/>
                                <strong>{duty?.date_time ? new Date(duty.date_time).toLocaleString("pt-BR", {
                                    dateStyle: "short",
                                    timeStyle: "short"
                                }) : "-"}</strong>


                            </div>
                            <div className="col-4 form-group">
                                <label>Data Fim</label><br/>
                                <strong>{duty?.date_time_end ? new Date(duty.date_time_end).toLocaleString("pt-BR", {
                                    dateStyle: "short",
                                    timeStyle: "short"
                                }) : "-"}</strong>


                            </div>
                            <div className="col-4 form-group">
                                <label>Valor do Plantão</label><br/>
                                <strong>{duty?.value ? `R$ ${parseFloat(duty.value).toFixed(2)}` : "-"}</strong>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-4 form-group">
                                <label>Aceitar o primeiro interessado?</label><br/>
                                <strong>{parseInt(dutyData?.self_approval) === 1 ? "Sim" : "Não"}</strong>
                            </div>
                            <div className="col-4 form-group">
                                <label>Local</label><br/>
                                <strong>{duty?.hospital?.name}</strong>
                            </div>

                            <div className="col-4 form-group">
                                <label>Especialidades</label><br/>
                                <div className="specialties-tags mt-2">
                                    {duty.specialties?.map((specialty) => (
                                        <Tag color="blue" key={specialty.id}>
                                            {specialty.name}
                                        </Tag>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 form-group">
                                <label>Departamento</label><br/>
                                <strong>{duty?.department.name}</strong>
                            </div>
                            <div className="col-4 form-group">
                                <label>Validar Credenciamento?</label><br/>
                                <strong>{duty?.validated_user === 1 ? "Sim" : "Não"}</strong>
                            </div>
                            <div className="col-4 form-group">
                                <label>Usuário Plantão</label><br/>
                                <strong>{duty?.accept_user?.name || "-"}</strong>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Observação</label><br/>
                            <span>{duty?.observation || "-"}</span>
                        </div>


                        {duty?.id > 0 && (
                            <div className="flex justify-center items-center h-screen bg-gray-100">
                                <EventEditor dutyEvent={duty}   onEventsChange={handleEventsChange} />
                            </div>
                        )}


                        {errorMessage && (
                            <div className="alert alert-danger mt-2" role="alert">
                                <div dangerouslySetInnerHTML={{__html: errorMessage}}/>
                            </div>
                        )}

                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            allEvents.length <= 1 && !(allEvents[0]?.extendedProps?.my_duty === 0) ? (
                                <Tooltip id="tooltip-save">
                                    Só é possível salvar se houver mais de um evento ou for um evento de outro usuário.
                                </Tooltip>
                            ) : <></>
                        }
                    >
                            <span className="d-inline-block">
                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={save}
                                    disabled={loadingSave || (allEvents.length <= 1 && !(allEvents[0]?.extendedProps?.my_duty === 0))}
                                    style={(allEvents.length <= 1 && !(allEvents[0]?.extendedProps?.my_duty === 0)) ? { pointerEvents: "none" } : {}}
                                >
                                    {loadingSave ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Salvando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-save me-1"></i> Salvar
                                        </>
                                    )}
                                </button>
                            </span>
                    </OverlayTrigger>

                    <button type="button" className="btn btn-secondary"  onClick={() =>handleClose()}>
                        <i className="fa fa-close"></i>{" "}Fechar
                    </button>
                </Modal.Footer>
            </Modal>


        </>
    );
};

export default PlantaoRepostModal;
